import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllCompraAnimal } from '../service';
import {
  LIST_COMPRA_ANIMAL,
  LIST_COMPRA_ANIMAL_PENDING,
  LIST_COMPRA_ANIMAL_SUCCESS,
  LIST_COMPRA_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaListAllCompraAnimal(action) {
  yield put({ type: LIST_COMPRA_ANIMAL_PENDING })

  try {
    const list = yield call(findAllCompraAnimal)
    
    yield put({ type: LIST_COMPRA_ANIMAL_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_COMPRA_ANIMAL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllCompraAnimal() {
  yield takeLatest(LIST_COMPRA_ANIMAL, sagaListAllCompraAnimal)
}